import { EventType, PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './msal.config';

export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.addEventCallback((event) => {
  console.log('[MSAL EVENT]', event.eventType);
  if (event.eventType === EventType.LOGIN_FAILURE) {
    console.error('[MSAL] LOGIN_FAILURE:', event.error);
  }

  if (event.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
    console.error('[MSAL] ACQUIRE_TOKEN_FAILURE:', event.error);
  }
});
